import React, { Component } from "react";
import { Collapse, Empty, CollapseProps } from "antd";
import Widget from "../../Theme/Widget/index.js";
import DetailedScheduleDayType from './DetailedScheduleDayType.js';
import getOffsetTime from '../../../utils/getOffsetTime.js';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

const { Panel } = Collapse;

const getOffsetTimeByDate = (timeStamp) => {
  if (dayjs.isDayjs(timeStamp)) {
    return timeStamp.utcOffset() * -1;
  } else {
    throw('Expected dayjs object');
  }
};

const DetailedScheduleTable = (props) => {
  props.detailedSchedule.map((schedule, index) => {
    return (
      {
        key: index,
        label: dayjs.unix(schedule.rdtDate).add(getOffsetTimeByDate(dayjs.unix(schedule.rdtDate)), 'minute').format('dddd, MMMM Do YYYY') || "",
        children: (
          <DetailedScheduleDayType
            offset={getOffsetTimeByDate(dayjs.unix(schedule.rdtDate))}
            detailedSchedule={schedule}
            resourceName={props.resourceName}
            index={index}
            openModal={props.openModal}
            canEdit={props.user.mobileSecurity.canEdit}
            securityLevels={props.user.securityLevels}
            resourcesId={props.resourcesId}
          />)
      }
    )
  });

  const itemsCollapse = props.detailedSchedule.map((schedule, index) => (
              {
                key: index, 
                label: dayjs.unix(schedule.rdtDate).add(getOffsetTimeByDate(dayjs.unix(schedule.rdtDate)), 'minute').format('dddd, MMMM Do YYYY') || "",
                children: (<DetailedScheduleDayType
                  offset={getOffsetTimeByDate(dayjs.unix(schedule.rdtDate))}
                  detailedSchedule={schedule}
                  resourceName={props.resourceName}
                  index={index}
                  openModal={props.openModal}
                  canEdit={props.user.mobileSecurity.canEdit}
                  securityLevels={props.user.securityLevels}
                  resourcesId={props.resourcesId}
                />)
              }
            ));
  return (

    <React.Fragment>
      {props.detailedSchedule.length > 0 ?
        (<Widget>
          <Collapse items = {itemsCollapse}>

          </Collapse>
        </Widget>)
        :
        (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)
      }
    </React.Fragment>
  )
}

DetailedScheduleTable.propTypes = {
  detailedSchedule: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user,
    detailedSchedule: state.detailedSchedules.detailedSchedules,
  }
}

export default connect(
  mapStateToProps,
)(DetailedScheduleTable);